<template>
  <ul class="c-hotspots">
    <li class="c-hotspots__item" :class="['c-hotspots__item--' + index]" @click="showDetail(index)" v-for="(item, index) in items" v-my-hotspot-shift>
      <span class="c-hotspots__icon"><svg class="icon icon-plus"><use xlink:href="#icon-plus"></use></svg></span>
      <span class="c-hotspots__text">{{ item.title }}</span>
    </li>
    <li class="c-hotspots__item c-hotspots__item--prosumer" @click="childGoToProsumer()" v-if="typeof childGoToProsumer === 'function'" v-my-hotspot-shift>
      <span class="c-hotspots__icon"><svg class="icon icon-plus"><use xlink:href="#icon-plus"></use></svg></span>
      <span class="c-hotspots__text">Explore a day in the life of a domestic prosumer of the future</span>
    </li>
  </ul>
</template>

<script>
import { MyHotspotShift } from '@/directives/my-hotspot-shift.js'
// import { IconPlus } from '@/components/standard/my-icons'

export default {
  name: 'my-hotspots',
  // components: {
  //   IconPlus
  // },
  directives: {
    MyHotspotShift
  },
  props: {
    items: {
      required: true,
      type: Array
    },
    showDetail: {
      required: true,
      type: Function
    },
    childGoToProsumer: {
      required: false,
      type: Function
    }
  }
}
</script>



// WEBPACK FOOTER //
// MyHotspots.vue?571c49f0